import { useEffect } from 'react';
import { useKioskFlowStore } from '../../stores/kiosk-flow-store';
import { OperatorFlowSelector } from '../organisms/OperatorFlowSelector';
import { OperatorFlowPanel } from '../organisms/OperatorFlowPanel';

export function KioskFlowManagementPage() {
  const reset = useKioskFlowStore((s) => s.reset);

  // Start fresh each time the page is opened
  useEffect(() => reset, [reset]);

  return (
    <div className="container mx-auto px-4 py-6 space-y-6">
      <div className="border-l-4 border-yellow-400 pl-4">
        <h1 className="text-xl font-semibold text-gray-900">Kiosk Flow Management</h1>
        <p className="text-gray-600 text-sm">Build and manage kiosk flows per operator</p>
      </div>

      <OperatorFlowSelector />
      <OperatorFlowPanel />
    </div>
  );
}
